module.exports = __webpack_public_path__ + "static/media/Antebraço.2412ce57.png";